/**
 * @flow
 * @relayHash d8842fcfda4e73fd3c7679cd81f9c4a2
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type ShopContainer_user$ref = any;
export type ShopViewQueryVariables = {|
  userId: string
|};
export type ShopViewQueryResponse = {|
  +user: ?{|
    +$fragmentRefs: ShopContainer_user$ref
  |}
|};
export type ShopViewQuery = {|
  variables: ShopViewQueryVariables,
  response: ShopViewQueryResponse,
|};
*/


/*
query ShopViewQuery(
  $userId: String!
) {
  user(userId: $userId) {
    ...ShopContainer_user
    id
  }
}

fragment ShopContainer_user on User {
  id
  userId
  causeId
  ...SwitchToV4Container_user
}

fragment SwitchToV4Container_user on User {
  id
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "userId",
    "type": "String!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "userId",
    "variableName": "userId"
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "ShopViewQuery",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "user",
        "storageKey": null,
        "args": (v1/*: any*/),
        "concreteType": "User",
        "plural": false,
        "selections": [
          {
            "kind": "FragmentSpread",
            "name": "ShopContainer_user",
            "args": null
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "ShopViewQuery",
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "user",
        "storageKey": null,
        "args": (v1/*: any*/),
        "concreteType": "User",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "id",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "userId",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "causeId",
            "args": null,
            "storageKey": null
          }
        ]
      }
    ]
  },
  "params": {
    "operationKind": "query",
    "name": "ShopViewQuery",
    "id": null,
    "text": "query ShopViewQuery(\n  $userId: String!\n) {\n  user(userId: $userId) {\n    ...ShopContainer_user\n    id\n  }\n}\n\nfragment ShopContainer_user on User {\n  id\n  userId\n  causeId\n  ...SwitchToV4Container_user\n}\n\nfragment SwitchToV4Container_user on User {\n  id\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'e35ea23ac8dc402bceb90a18de6053fe';
module.exports = node;
